import ApiService from "../../../../services/ApiService";

export const fetchUserEmails = (userId: number, setEmails: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`users/${userId}/emails`)
    .then((response) => setEmails(response.data.emails))
    .catch((error) => console.error("An error occurred while fetching user's emails", error))
    .finally(() => setLoading(false));
};

export const openEmail = (email: any, setShow: Function, setContent: Function) => {
  setContent(email.body);
  setShow(true);
};
